import * as Config from 'Config/public';
import bootstrap from './bootstrap';

const cookieApprovalButton = document.querySelector('#cookies-approval');
if (cookieApprovalButton) {
    cookieApprovalButton.addEventListener('click', () => {
        $('#cookiesAccept').hide();
        window.writeAcceptCookie('Y');
    });
}

bootstrap(Config);
